import React, { useState, useEffect } from 'react';
import { Modal, Table, Input, Button, Spin, Empty, Popover } from 'antd';
import { SearchOutlined, DownloadOutlined, CloseOutlined } from '@ant-design/icons';
import './DayDetailModal.css';
import axios from 'axios';
import cubejs from '@cubejs-client/core';
import { handleQueryClientViewDay } from './index';
import moment from 'moment';
import { processModalityData } from './index';

const DayDetailModal = ({ visible, onClose, date, podName, dayData, modality ,currentUser,allPodData,targetMetrics,isrTargetAchieved}) => {
  const [loading, setLoading] = useState(false);
  const [clientData, setClientData] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  
  // Format date for display and API
//   //console.log(podName, 'podName')
  const formattedDate = date ? new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }) : '';
  
  const apiDateFormat = date ? new Date(date).toISOString().split('T')[0] : '';
  
  // Fetch data when modal opens
  useEffect(() => {
    const cubejsApi = cubejs(
        process.env.REACT_APP_MARKET_SHARE_GET_STATE_WISE_DATA_TOKEN,
        {
            apiUrl: process.env.REACT_APP_MARKET_SHARE_GET_STATE_WISE_DATA,
        }
    );
    if (visible && date && podName) {
      fetchDayClientData(cubejsApi);
    }
  }, [visible, date, podName]);
  
  // Filter data when search text changes
  useEffect(() => {
    if (clientData.length > 0) {
      const filtered = clientData.filter(client => 
        client.client_name.toLowerCase().includes(searchText.toLowerCase()) ||
        client.client_id.toString().includes(searchText)
      );
      setFilteredData(filtered);
    }
  }, [searchText, clientData]);
  
  // Fetch client data for the selected day and pod
  const fetchDayClientData = async (cubejsApi) => {
    setLoading(true);
    //console.log(podName, 'podName')
    const last11month = moment(new Date(apiDateFormat)).subtract(11, 'months').startOf('month').format('YYYY-MM-DD');
    let client_ids = podName?.client_ids||''
    let others=[]
    if(podName?.name=='Others'&& targetMetrics?.length>0){
       targetMetrics?.map(pod=>{
        others=[...others,...pod?.client_ids?.split(',').map(p=>p.trim())]
       })
    }
    try {
        await cubejsApi
        .load(handleQueryClientViewDay(currentUser, apiDateFormat,modality, last11month, client_ids, others))
        .then((resultSet) => {
            // const modifiedData = resultSet?.loadResponses[0]?.data?.map(data => {
            //     return {
            //         client_id: data?.['Contribution.client_fk'],
            //         client_name: data?.['Contribution.client_name'],
            //         case_count: data?.['Contribution.total_case_count'],
            //         amount: data?.['Contribution.amount'],
            //         pincode: data?.['Contribution.pincode'],
            //     }
            // })
            const pivotedData = resultSet.tablePivot({
                x: ["Contribution.client_fk", "Contribution.client_name", "Contribution.total_case_count", "Contribution.amount"],
                y: ["Contribution.modality","Contribution.final_discount"]
            })

            console.log(pivotedData,'pivotedData')
            const modifiedData = pivotedData.map(data => {
                const processedData = processModalityData(data);
                
                const totalCaseCount = Object.values(processedData.modalities).reduce((total, modality) => {
                    return total + Object.values(modality.splits)
                        .filter(value => typeof value === 'number')
                        .reduce((sum, count) => sum + count, 0);
                }, 0);
            
                // Calculate total incentive amount across all modalities and splits
                const totalIncentiveAmount = Object.values(processedData.modalities).reduce((total, modality) => {
                    return total + Object.values(modality.splits.incentive_amount)
                        .reduce((sum, amount) => sum + amount, 0);
                }, 0);

                return {
                    ...processedData,
                    case_count: totalCaseCount,
                    incentive_amount: totalIncentiveAmount
                };
            })

            
            console.log(modifiedData, 'modifiedData')
            // //console.log(others, 'others')
            if(podName?.name=='Others'&& targetMetrics?.length>=0){
            //console.log(modifiedData?.filter(client=>!others?.includes(client?.pincode)), 'modifiedData')
            setClientData(modifiedData?.filter(client=>!others?.includes(client?.client_id)));
            setFilteredData(modifiedData?.filter(client=>!others?.includes(client?.client_id)));
            }else{
                setClientData(modifiedData)
                setFilteredData(modifiedData)
            }
        })
    } catch (error) {
      console.error('Error fetching day client data:', error);
      // Use mock data on error for development
    //   const mockData = generateMockData();
    //   setClientData(mockData);
    //   setFilteredData(mockData);
    } finally {
      setLoading(false);
    }
  };

  
  // Export to CSV
  const exportToCSV = () => {
    const headers = ['Client ID', 'Client Name', 'Case Count', 'Amount'];
    const dataRows = filteredData.map(client => [
      client.client_id,
      client.client_name,
      client.case_count,
      client.amount
    ]);
    
    const csvContent = [
      headers.join(','),
      ...dataRows.map(row => row.join(','))
    ].join('\n');
    
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', `${podName}_${apiDateFormat}_clients.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  
  // Table columns
  const columns = [
    {
      title: 'Client Name',
      dataIndex: 'client_name',
      key: 'client_name',
      sorter: (a, b) => a.client_name.localeCompare(b.client_name),
    },
    {
      title: 'Total Cases',
      dataIndex: 'case_count',
      key: 'case_count',
      render: (_, record) => {
        return  <div>
            <div style={{fontSize:'12px',color:'#000'}}>₹ {isrTargetAchieved>0 ? <> {record?.modalities?.XRAY?.amount+record?.modalities?.CT?.amount+record?.modalities?.MRI?.amount+record?.modalities?.NM?.amount}</> : 0}</div>
            <div style={{fontSize:'10px',color:'#000'}}>({record?.modalities?.XRAY?.total+record?.modalities?.CT?.total+record?.modalities?.MRI?.total+record?.modalities?.NM?.total})</div>
            </div>
      }
    },
    {
        title:'XRAY',
        dataIndex:'XRAY',
        key:'XRAY',
        render: (_, record) => {
            return <div>
                <div style={{fontSize:'12px',color:'#000'}}>₹{isrTargetAchieved>0 ? <> {record?.modalities?.XRAY?.amount}</> : 0}</div>
                <div style={{fontSize:'10px',color:'#000'}}>({record?.modalities?.XRAY?.total})</div>
            </div>
        }
    },
    {
        title:'CT',
        dataIndex:'CT',
        key:'CT',
        render: (_, record) => {
            return <div>
                <div style={{fontSize:'12px',color:'#000'}}>₹{isrTargetAchieved>0 ? <> {record?.modalities?.CT?.amount}</> : 0}</div>
                <div style={{fontSize:'10px',color:'#000'}}>({record?.modalities?.CT?.total})</div>
            </div>
        }
    },
    {
        title:'MRI',
        dataIndex:'MRI',
            key:'MRI',
        render: (_, record) => {
            return <div>
                <div style={{fontSize:'12px',color:'#000'}}>₹{isrTargetAchieved>0 ? <> {record?.modalities?.MRI?.amount}</> : 0}</div>
                <div style={{fontSize:'10px',color:'#000'}}>({record?.modalities?.MRI?.total})</div>
            </div>
        }
    },
    {
        title:'NM',
        dataIndex:'NM',
        key:'NM',
        render: (_, record) => {
            return <div>
                 <div style={{fontSize:'12px',color:'#000'}}>₹{isrTargetAchieved>0 ? <> {record?.modalities?.NM?.amount}</> : 0}</div>
                <div style={{fontSize:'10px',color:'#000'}}>({record?.modalities?.NM?.total})</div>
               
            </div>
        }
    },
    {
      title: 'Modality Details',
      key: 'modality_details',
      render: (_, record) => (
        <Popover
          title="Modality Breakdown"
          content={
            <div className="modality-breakdown">
              {Object.entries(record.modalities).map(([modalityName, modalityData]) => {
                if (modalityData.total > 0) {
                  return (
                    <div key={modalityName} className="modality-section">
                      <div className="modality-header">
                        <span className={`modality-name ${modalityName.toLowerCase()}`}>
                          {modalityName}
                        </span>
                        <span>Total: {modalityData.total}</span>
                      </div>
                      <div className="discount-splits">
                        {Object.entries(modalityData.splits).map(([discount, count]) => {
                          if (discount !== 'incentive_amount' && count > 0) {
                            return (
                              <div key={discount} className="discount-row">
                                <span>{discount}</span>
                                <span>{count} cases</span>
                                <span>₹{isrTargetAchieved>0 ? <> {modalityData.splits.incentive_amount[discount]}</> : 0}</span>
                              </div>
                            );
                          }
                          return null;
                        })}
                      </div>
                    </div>
                  );
                }
                return null;
              })}
            </div>
          }
        >
          <Button type="link">View Details</Button>
        </Popover>
      ),
    },
  ];
  
  return (
    <Modal
      title={
        <div className="day-modal-title">
          <div>
            <span className="day-date">{formattedDate}</span>
            <span className="day-pod">{podName?.name}</span>
          </div>
          <div className="day-summary">
            <div className="summary-item">
              <span className="summary-label">Total:</span>
              <span className="summary-value">{clientData?.reduce((sum, client) => sum + parseInt(client.modalities?.XRAY?.total)+parseInt(client.modalities?.CT?.total)+parseInt(client.modalities?.MRI?.total)+parseInt(client.modalities?.NM?.total), 0)}</span>
            </div>
            <div className="summary-item">
              <span className="summary-label">Amount :</span>
              <span className="summary-value">₹{isrTargetAchieved>0 ? <> {clientData?.reduce((sum, client) => sum + parseInt(client.modalities?.XRAY?.amount)+parseInt(client.modalities?.CT?.amount)+parseInt(client.modalities?.MRI?.amount)+parseInt(client.modalities?.NM?.amount), 0)}</> : 0}</span>
            </div>
           
          </div>
        </div>
      }
      open={visible}
      onCancel={onClose}
      footer={null}
      width={1000}
      className="day-detail-modal"
      closeIcon={<CloseOutlined />}
    >
      <div className="modal-content">
        <div className="modal-header">
          <Input
            placeholder="Search by client name or ID..."
            prefix={<SearchOutlined />}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            className="search-input"
            allowClear
          />
          {/* <Button 
            icon={<DownloadOutlined />} 
            onClick={exportToCSV}
            className="export-button"
            disabled={filteredData.length === 0}
          >
            Export
          </Button> */}
        </div>
        
        {loading ? (
          <div className="loading-container">
            <Spin size="large" />
            <p>Loading client data...</p>
          </div>
        ) : filteredData.length > 0 ? (
          <Table 
            dataSource={filteredData} 
            columns={columns} 
            pagination={{ 
              pageSize: 10,
              showSizeChanger: true,
              pageSizeOptions: ['10', '20', '50'],
              showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} clients`
            }}
            className="client-table"
            rowClassName="client-row-day"
            summary={pageData => {
              const totalCases = pageData.reduce((sum, client) => sum + parseInt(client.case_count), 0);
              const totalAmount = pageData.reduce((sum, client) => sum + parseInt(client.case_count), 0);
              
              return (
                <Table.Summary fixed>
                  <Table.Summary.Row className="summary-row">
                    <Table.Summary.Cell index={0} colSpan={1}>Total</Table.Summary.Cell>
                    <Table.Summary.Cell index={1} colSpan={1}>
                        <div style={{fontSize:'12px',color:'#000'}}>
                        ₹{isrTargetAchieved>0 ? <> {clientData?.reduce((sum, client) => sum + parseInt(client.modalities?.XRAY?.amount)+parseInt(client.modalities?.CT?.amount)+parseInt(client.modalities?.MRI?.amount)+parseInt(client.modalities?.NM?.amount), 0)}</> : 0}
                        </div>
                        <div style={{fontSize:'10px',color:'#000'}}>
                            ({clientData?.reduce((sum, client) => sum + parseInt(client.modalities?.XRAY?.total)+parseInt(client.modalities?.CT?.total)+parseInt(client.modalities?.MRI?.total)+parseInt(client.modalities?.NM?.total), 0)})
                        </div>
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={2}>
                        <div style={{fontSize:'12px',color:'#000'}}>
                        ₹{isrTargetAchieved>0 ? <> {clientData?.reduce((sum, client) => sum + parseInt(client.modalities?.XRAY?.amount), 0)}</> : 0}
                        </div>
                        <div style={{fontSize:'10px',color:'#000'}}>
                            ({clientData?.reduce((sum, client) => sum + parseInt(client.modalities?.XRAY?.total), 0)})
                        </div>
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={3}>
                        <div style={{fontSize:'12px',color:'#000'}}>
                        ₹{isrTargetAchieved>0 ? <> {clientData?.reduce((sum, client) => sum + parseInt(client.modalities?.CT?.amount), 0)}</> : 0}
                        </div>
                        <div style={{fontSize:'10px',color:'#000'}}>
                            ({clientData?.reduce((sum, client) => sum + parseInt(client.modalities?.CT?.total), 0)})
                        </div>
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={4}>
                        <div style={{fontSize:'12px',color:'#000'}}>
                        ₹{isrTargetAchieved>0 ? <> {clientData?.reduce((sum, client) => sum + parseInt(client.modalities?.MRI?.amount), 0)}</> : 0}
                        </div>
                        <div style={{fontSize:'10px',color:'#000'}}>
                            ({clientData?.reduce((sum, client) => sum + parseInt(client.modalities?.MRI?.total), 0)})
                        </div>
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={5}>
                        <div style={{fontSize:'12px',color:'#000'}}>
                        ₹{isrTargetAchieved>0 ? <> {clientData?.reduce((sum, client) => sum + parseInt(client.modalities?.NM?.amount), 0)}</> : 0}
                        </div>
                        <div style={{fontSize:'10px',color:'#000'}}>
                            ({clientData?.reduce((sum, client) => sum + parseInt(client.modalities?.NM?.total), 0)})
                        </div>
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={6}></Table.Summary.Cell>
                  </Table.Summary.Row>
                </Table.Summary>
              );
            }}
          />
        ) : (
          <Empty 
            description={searchText ? "No clients match your search" : "No client data available for this day"} 
            className="empty-data"
          />
        )}
      </div>
    </Modal>
  );
};

export default DayDetailModal; 